import React from 'react'
import t from '../../../../../translations/main'
import { Trans } from 'react-i18next'
import utils from '../../../../../components/Organisms/Form/utils'

import Font from 'src/components/Core/Typography/Font/Font'
import Accordion from 'src/components/Organisms/Accordion/Accordion'
import { ExternalLink } from 'src/components/Core/Styles/Link'

// @ts-ignore:next-line
const pleaseSelectLabel = (
  <Font key='pleaseSelectLabel' ellipsis={false}>
    <Trans i18nKey={'onboarding.forms.CorporateAccount.ClearingAccountPreferencesForm.visualOnly.pleaseSelectLabel'} />
  </Font>
)

export const clientDocumentation = <ExternalLink href='https://www.sucdenfinancial.com/en/client-documentation-and-disclosures/' >www.sucdenfinancial.com/en/client-documentation-and-disclosures/</ExternalLink>

const pleaseNoteAccordion = (
  <Accordion
    key='pleaseNoteAccordion'
    margin='16px 0 16px 0'
    title={t('onboarding.forms.CorporateAccount.ClearingAccountPreferencesForm.visualOnly.pleaseNoteAccordion.title')}
    isOpen>
    {/* @ts-ignore */}
    <Trans i18nKey={'onboarding.forms.CorporateAccount.ClearingAccountPreferencesForm.visualOnly.pleaseNoteAccordion.content'} components={{ clientDocumentation }}/>
  </Accordion>
)

// @ts-ignore:next-line
const areYouBrokerLabel = (
  <Font key='areYouBrokerLabel' ellipsis={false}>
    <Trans i18nKey={'onboarding.forms.CorporateAccount.ClearingAccountPreferencesForm.visualOnly.areYouBrokerLabel'} />
  </Font>
)

// @ts-ignore:next-line
const omnibusAccountText = (
  <Font key='omnibusAccountLabel' ellipsis={false}>
    <Trans i18nKey={'onboarding.forms.CorporateAccount.ClearingAccountPreferencesForm.visualOnly.omnibusAccountLabel'} />
  </Font>
)

const config = utils.injectTranslation({
  id: 'ClearingAccountPreferencesForm',
  path: 'onboarding.forms.CorporateAccount.ClearingAccountPreferencesForm.inputs',
  keysToRemove: ['visual'],
  content: [
    {
      componentType: 'grid',
      props: {
        marginBottom: '16px',
        rowGap: '16px'
      },
      content: [
        {
          componentType: 'accordion',
          visualComponent: pleaseNoteAccordion,
        },
        {
          componentType: '',
          visualComponent: pleaseSelectLabel,
        },
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'engageInClearedBusiness',
            minHeight: '0',
            margin: '8px 0 0 0',
            marginBottom: '16px',
            labelBold: true,
            dataList: [
              {
                id: 'engageInClearedBusiness1',
                label: t('components.forms.labels.yes'),
                value: 'true',
                minWidth: '24px'
              },
              {
                id: 'engageInClearedBusiness2',
                label: t('components.forms.labels.no'),
                value: 'false',
                minWidth: '24px'
              },
            ],
            removeLabelEllipsis: true,
            required: true,
          },
        },
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'londonMetalExchange',
            minHeight: '0',
            margin: '0 0 0 4%',
            marginBottom: '0',
            dataList: [
              {
                id: 'londonMetalExchange1',
                label: t('onboarding.forms.CorporateAccount.ClearingAccountPreferencesForm.radioOptions.isa'),
                value: 'individuallySegregatedAccount',
                minWidth: '24px'
              },
              {
                id: 'londonMetalExchange2',
                label: t('onboarding.forms.CorporateAccount.ClearingAccountPreferencesForm.radioOptions.osa'),
                value: 'omnibusSegregatedAccount',
                minWidth: '24px'
              },
            ],
            removeLabelEllipsis: true,
          },
        },
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'frieghtDerivatives',
            minHeight: '0',
            margin: '0 0 0 4%',
            marginBottom: '0',
            dataList: [
              {
                id: 'frieghtDerivatives1',
                label: t('onboarding.forms.CorporateAccount.ClearingAccountPreferencesForm.radioOptions.isa'),
                value: 'individuallySegregatedAccount',
                minWidth: '24px'
              },
              {
                id: 'frieghtDerivatives2',
                label: t('onboarding.forms.CorporateAccount.ClearingAccountPreferencesForm.radioOptions.osa'),
                value: 'omnibusSegregatedAccount',
                minWidth: '24px'
              },
            ],
            removeLabelEllipsis: true,
          },
        },
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'iceClearEurope',
            minHeight: '0',
            margin: '0 0 16px 4%',
            marginBottom: '0px',
            dataList: [
              {
                id: 'iceClearEurope1',
                label: t('onboarding.forms.CorporateAccount.ClearingAccountPreferencesForm.radioOptions.isa'),
                value: 'individuallySegregatedAccount',
                minWidth: '24px'
              },
              {
                id: 'iceClearEurope2',
                label: t('onboarding.forms.CorporateAccount.ClearingAccountPreferencesForm.radioOptions.osa'),
                value: 'omnibusSegregatedAccount',
                minWidth: '24px'
              },
            ],
            removeLabelEllipsis: true,
          },
        },
        {
          componentType: '',
          visualComponent: areYouBrokerLabel,
        },
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'iceFuturesUS',
            minHeight: '0',
            margin: '8px 0 0 0',
            marginBottom: '16px',
            labelBold: true,
            dataList: [
              {
                id: 'iceFuturesUS1',
                label: t('components.forms.labels.yes'),
                value: 'true',
                minWidth: '24px'
              },
              {
                id: 'iceFuturesUS2',
                label: t('components.forms.labels.no'),
                value: 'false',
                minWidth: '24px'
              },
            ],
            removeLabelEllipsis: true,
            required: true,
          },
        },
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'cme',
            minHeight: '0',
            marginBottom: '0',
            labelBold: true,
            dataList: [
              {
                id: 'cme1',
                label: t('components.forms.labels.yes'),
                value: 'true',
                minWidth: '24px'
              },
              {
                id: 'cme2',
                label: t('components.forms.labels.no'),
                value: 'false',
                minWidth: '24px'
              },
            ],
            removeLabelEllipsis: true,
            required: true,
          },
        },
        {
          componentType: '',
          visualComponent: omnibusAccountText,
        },
      ]
    }
  ]
})

export default config
